import { ReactComponent as Charts } from '../../../assets/charts-icon.svg';
import { Button } from './charts-button.styles';

const ChartsButton = ({
    active,
    disabled,
    onClick,
}: {
    active: boolean;
    disabled: boolean;
    onClick: () => void;
}) => {
    return (
        <Button
            disabled={disabled}
            onClick={onClick}
            variant="outlined"
            color="primary"
        >
            <Charts height={30} />
            {active ? 'Vedi Grafici' : 'Nascondi Grafici'}
        </Button>
    );
};

export default ChartsButton;
